import { render, staticRenderFns } from "./RecipientTransferFiles.vue?vue&type=template&id=9e4912fa&"
import script from "./RecipientTransferFiles.vue?vue&type=script&lang=js&"
export * from "./RecipientTransferFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports